import type { TOC } from '@ember/component/template-only'
import { hash } from '@ember/helper'
import { ManageActionsDiv } from 'teacher-ui-client/components/tiles/manage-actions/div'
import { eq } from 'ember-truth-helpers'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Args {
  title: string
  themeKey?: ThemeKeys
}

interface Signature {
  Args: Args
  Element: HTMLElement
  Blocks: {
    default: [{ formArea: any; actionsArea: any }]
  }
}

export const TilesManageActions: TOC<Signature> = <template>
  <section
    class="rounded-md
      {{if (eq @themeKey ThemeKeys.blue) 'bg-oceany-blue-300'}}
      {{if (eq @themeKey ThemeKeys.green) 'bg-ms-green-300'}}
      {{if (eq @themeKey ThemeKeys.darkBlue) 'bg-wl-blue-250'}}"
    ...attributes
  >
    <h3 class="mb-2 text-white">{{@title}}</h3>
    <div class="flex flex-col gap-4 lg:flex-row">
      {{yield
        (hash
          formArea=(component ManageActionsDiv class="bg-white rounded-md p-3 space-y-2 grow")
          actionsArea=(component ManageActionsDiv class="flex flex-col flex-wrap gap-2 items-stretch")
        )
      }}
    </div>
  </section>
</template>

export default TilesManageActions
